<template>
    <div>
        Categorie Listing
    </div>
</template>
<script>
    export default {
        name: 'Category',
        data() {
            return {}
        },
        methods: {
        }
    }
</script>
